import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updateNotificationSettings,
  markNotificationAsRead,
  markAllNotificationsAsRead,
} from './request';
import {
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from '@/api/queries/notifications';
import toast from 'react-hot-toast';

export const useUpdateNotificationSettings = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: updateNotificationSettings,
    onSuccess: ({ response }) => {
      toast.success(response);
      onSuccess?.();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update notification settings');
    },
  });
};

export const useMarkNotificationAsRead = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      });
      onSuccess?.();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to mark notification as read');
    },
  });
};

export const useMarkAllNotificationsAsRead = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      });
      onSuccess?.();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to mark all as read');
    },
  });
};
